import { createContext } from "react";

/** setIndex context that is provided from App.js */
const setIndexIdContext = createContext();

export default setIndexIdContext;
